export const DiffPurchaseMenus = {
    open: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clipboard-check",
            emit: "kooi:offer:menu:pdf_validation",
            key: "validatepdf",
            text: "labels.pdf.validation.pdf_validation",
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => (item.type == "d_po" || item.type == "d_po")) != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.offer.menus.reject"
        },
    ]
};
